<template><svg width="24" height="24" xmlns="http://www.w3.org/2000/svg">
  <path fill="currentColor" fill-rule="evenodd" d="M12 17.3392857L6 8.66071429 18 8.66071429z" />
</svg>
</template>